<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<mat-tab-group [selectedIndex]="selectedIndex">
  <mat-tab label="Bayernwetter lang">
    <app-br-langwetter-bericht [langWetterbericht]="brBericht?.langWetterBR"></app-br-langwetter-bericht>
  </mat-tab>
  <mat-tab label="Bayernwetter kurz">
    <app-br-kurzwetter-bericht [kurzWetterbericht]="brBericht?.kurzWetterBR"></app-br-kurzwetter-bericht>
  </mat-tab>
  <mat-tab label="Biowetter">
    <app-br-biowetter-bericht [bioWetterbericht]="brBericht?.bioWetterBR"></app-br-biowetter-bericht>
  </mat-tab>
  <mat-tab label="Regionalwetter">
    <app-br-regionalwetter-bericht [regionalWetterbericht]="brBericht?.regionalWetterBR"></app-br-regionalwetter-bericht>
  </mat-tab>
  <mat-tab label="Bergwetter">
    <app-br-bergwetter-bericht [bergWetterbericht]="brBericht?.bergWetterBR"></app-br-bergwetter-bericht>
  </mat-tab>
  <mat-tab label="Rundschauwetter">
    <app-br-rundschauwetter-bericht [rundschauWetterbericht]="brBericht?.rundschauWetterBR"></app-br-rundschauwetter-bericht>
  </mat-tab>
  <mat-tab label="Siebentagewetter">
    <app-br-siebentagewetter-bericht [siebentageWetterbericht]="brBericht?.siebenTageWetterBR"></app-br-siebentagewetter-bericht>
  </mat-tab>
  <mat-tab label="Abendschauwetter">
    <app-br-abendschauwetter-bericht [abendschauWetterbericht]="brBericht?.abendschauWetterBR"></app-br-abendschauwetter-bericht>
  </mat-tab>
</mat-tab-group>
